import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { motion } from 'framer-motion';

// material -------------------------------------------------------------

import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

// import Logo from './Logo';
const Logo = dynamic(() => import('./Logo'), { ssr: false });

// ----------------------------------------------------------------------


export default function LoadingScreen({ ...other }) {

  const router = useRouter();
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const handleStart = (url) => {

      const isUnSeved = JSON.parse(sessionStorage.getItem('unsaved_changes_dialog'));

      console.log('isUnSeved : ', isUnSeved)

      if ((url !== router.asPath) && (!isUnSeved))
        setLoading(true);

    };

    const handleComplete = (url) => {

      const { asPath, pathname, route } = router;

      console.log("handleComplete : ", { url, asPath, pathname, router })

      const regex = new RegExp(`${pathname}*`);

      switch (true) {
        case (route === pathname):
        case (regex.test(url)):
        case (url === asPath):
          {
            setLoading(false);
          } break;
      }

    };


    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };

  });

  if (loading) {
    return (
      <RootStyle {...other}>
        <motion.div
          initial={{ rotateY: 0 }}
          animate={{ rotateY: 360 }}
          transition={{
            duration: 2,
            ease: 'easeInOut',
            repeatDelay: 1,
            repeat: Infinity,
          }}
        >
          {/* <Logo sx={{ width: 64, height: 64 }} /> */}
          <img style={{ width: 55, heig: 55 }} src="/static/img/logo/big-c-logo-2.svg" />
        </motion.div>

        <Box
          component={motion.div}
          animate={{
            scale: [1.2, 1, 1, 1.2, 1.2],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          sx={{
            width: 100,
            height: 100,
            borderRadius: '25%',
            position: 'absolute',
            border: (theme) =>
              `solid 3px ${alpha(theme.palette.primary.dark, 0.24)}`,
          }}
        />

        <Box
          component={motion.div}
          animate={{
            scale: [1, 1.2, 1.2, 1, 1],
            rotate: [0, 270, 270, 0, 0],
            opacity: [1, 0.25, 0.25, 0.25, 1],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{
            ease: 'linear',
            duration: 3.2,
            repeat: Infinity,
          }}
          sx={{
            width: 120,
            height: 120,
            borderRadius: '25%',
            position: 'absolute',
            border: (theme) =>
              `solid 8px ${alpha(theme.palette.primary.dark, 0.24)}`,
          }}
        />
      </RootStyle>
    );
  }
  return null;
}

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9998,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------
